import React from "react";
import { Link } from "gatsby";
// import PropTypes from "prop-types";

import styles from "./header-bar.module.scss";

const HeaderBar = () => (
  <nav>
    <div className={styles.bar}>
      <div className={styles.pageRep}>Anthony W. Ho</div>
      <div>
        <Link className={styles.blog} to="/code">Words</Link>
        <Link className={styles.about} to="/about">About</Link>
        <Link className={styles.home} to="/">Home</Link>
      </div>
    </div>
  </nav>
);

HeaderBar.propTypes = {};
HeaderBar.defaultProps = {};

export default HeaderBar;